import { configureStore, PreloadedState } from '@reduxjs/toolkit'
import isEqual from 'lodash.isequal'
import { createSelectorCreator, defaultMemoize } from 'reselect'
import { rootReducer } from './reducers'

export const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  isEqual
)

// const middleware: any = [...getDefaultMiddleware({ thunk: true })];
export type RootState = ReturnType<typeof rootReducer>

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: true
      }),
    preloadedState
  })

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot?.accept('./reducers', () => {
      return store.replaceReducer(rootReducer)
    })
  }

  return store
}

export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
